import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import Spinner from '../../../components/Spinner';
import BodyWhithdrawal from '../../../components/wallet/BodyWhithdrawal';
import { useCashBalance } from '../../../context/CashBalanceContext';

const WalletWithdrawal = () => {
  const { balance: balanceData, loading: loadingBalance } = useCashBalance();

  const fileAs = {
    currency: 'pesos',
    fileAs: 'file as',
    fileAsComplete: 'file as complete',
    risk: 'agresivo',
    profit: '10',
  };

  if (loadingBalance) {
    return <Spinner />;
  }

  return (
    <>
      <HeaderLayout fileAs={fileAs} />
      <BodyWhithdrawal balanceData={balanceData} />
    </>
  );
};

export default WalletWithdrawal;
